function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuoteFiil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.468 18.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.526 23.516a1.6 1.6 0 0 0 1.081-.571l3.243-2.927 5.748.009a3.764 3.764 0 0 0 4.131-4.14V9.058a3.764 3.764 0 0 0-4.129-4.14H8.393a3.768 3.768 0 0 0-4.131 4.14v6.829a3.76 3.76 0 0 0 4.069 4.131h.352v2.549c0 .579.307.949.843.949zm.141-11.962A1.827 1.827 0 0 1 11.583 9.7a2.043 2.043 0 0 1 2 2.224 3.205 3.205 0 0 1-2.707 3.3.433.433 0 0 1-.466-.422c0-.211.105-.36.422-.439a2.422 2.422 0 0 0 1.617-1.345h-.105a1.27 1.27 0 0 1-1.011.369 1.677 1.677 0 0 1-1.666-1.833zm4.816 0A1.825 1.825 0 0 1 16.391 9.7a2.05 2.05 0 0 1 2 2.224 3.2 3.2 0 0 1-2.707 3.3.426.426 0 0 1-.457-.422c0-.211.105-.36.413-.439a2.422 2.422 0 0 0 1.617-1.345h-.105a1.278 1.278 0 0 1-1.02.369 1.676 1.676 0 0 1-1.649-1.833z",
    transform: "translate(-4.262 -4.918)",
    style: {
      fill: "currentColor"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteFiil);
export default __webpack_public_path__ + "static/media/quote-fiil.32da6789.svg";
export { ForwardRef as ReactComponent };